<div class="card border-0 shadow-sm pt-0 mb-4">
    <div class="card-header fs-5 fw-medium">Approvals</div>
    <div class="card-body">
        <div class="row g-3 mt-3">
            @if (incidentReport.approvals && incidentReport.approvals.length > 0) {
                @for (approval of incidentReport.approvals; track $index) {
                    <div class="col-md-6">
                        <div class="row align-items-center g-0">
                            <div class="col-sm-7">
                                <user-avatar-email [email]="approval.employee?.email" [name]="approval.employee?.name"
                                    [avatarUrl]="approval.employee?.avatarUrl"></user-avatar-email>
                            </div>
                            <div class="col-sm-5 d-flex justify-content-sm-start">
                                <div class="d-flex align-items-center mt-2 mt-sm-0">
                                    <strong class="me-2">Date:</strong>
                                    <span>{{ approval.approvedDate | date:dateTimeFormat }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                } 
            } @else{
                <div class="col-12 text-center">
                    <p class="text-muted">No approvals</p>
                </div>
            }
        </div>
    </div>
</div>